import { Link } from 'react-router-dom'

// Back link shared by Dashboard, ARV and Flip: the exports' arrow-back-green glyph (Flip btn_6,
// Dashboard btn_48, ARV btn_18, one path translated to its own origin), 4 before 13/600 #4AA52A text.
function BackArrow() {
  return (
    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" aria-hidden="true" className="shrink-0">
      <path d="M0.67 3.997H10.67M4.67 7.331L0.67 3.997L4.67 0.664" stroke="#4AA52A" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function BackLink({ to, children }) {
  return (
    <Link
      to={to}
      className="flex w-fit items-center gap-x-[4px] text-[13px] leading-[18px] font-semibold text-[#4AA52A] hover:opacity-70 transition-opacity outline-none focus-visible:ring-2 focus-visible:ring-brand-green rounded-[2px]"
    >
      <BackArrow />
      <span>{children}</span>
    </Link>
  )
}
